import { render, staticRenderFns } from "./TablePolizas.vue?vue&type=template&id=49efa5f6&scoped=true&"
import script from "./TablePolizas.vue?vue&type=script&lang=js&"
export * from "./TablePolizas.vue?vue&type=script&lang=js&"
import style0 from "./TablePolizas.vue?vue&type=style&index=0&id=49efa5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49efa5f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow})
